import React from 'react';
import TextFieldWrapper from './FormFieldTypes/TextFieldWrapper';
import SelectFieldWrapper from './FormFieldTypes/SelectFieldWrapper';
import RadioGroupWrapper from './FormFieldTypes/RadioGroupWrapper';
import TextareaWrapper from './FormFieldTypes/TextareaWrapper';
import DatePickerWrapper from './FormFieldTypes/DatePickerWrapper';
import DateTimePickerWrapper from './FormFieldTypes/DateTimePickerWrapper';

const FormField = ({ field, value, onChange, error }) => {
  switch (field.type) {
    case 'text':
    case 'email':
    case 'number':
    case 'password':
      return (
        <TextFieldWrapper
          field={field}
          value={value}
          onChange={onChange}
          error={error}
        />
      );
    case 'textarea':
      return (
        <TextareaWrapper
          field={field}
          value={value}
          onChange={onChange}
          error={error}
        />
      );
    case 'select':
      return (
        <SelectFieldWrapper
          field={field}
          value={value}
          onChange={onChange}
          error={error}
        />
      );
    case 'radio':
      return (
        <RadioGroupWrapper
          field={field}
          value={value}
          onChange={onChange}
          error={error}
        />
      );
    case 'date':
      return (
        <DatePickerWrapper
          field={field}
          value={value}
          onChange={onChange}
          error={error}
        />
      );
       case 'datetime':
      return (
        <DateTimePickerWrapper
          field={field}
          value={value}
          onChange={onChange}
          error={error}
        />
      );
    default:
      return null;
  }
};

export default FormField;
